module.exports = __webpack_public_path__ + "img/at.dd9515ba.svg";